// Features/Product-Quantity/Component.ts
class Component extends HTMLElement {
  timeout;
  parts;
  constructor() {
    super();
  }
  connectedCallback() {
    this.queryParts();
    this.listen();
  }
  queryParts() {
    this.parts = {
      quantity: this.querySelector(`.QuantitySelector__CurrentQuantity`),
      limit: this.querySelector(`.Product-Quantity-Limit`)
    };
  }
  listen() {
    this.parts.quantity.addEventListener("input", this.onValidate.bind(this));
  }
  onValidate() {
    const { quantity, limit } = this.parts;
    if (!limit)
      return;
    clearTimeout(this.timeout);
    delete this.timeout;
    const { value, max } = quantity;
    const maximum = parseInt(max), amount = parseInt(value);
    if (maximum === amount)
      return;
    if (maximum < amount) {
      limit.ariaHidden = String(false);
      limit.querySelector(`span`).innerText = String(maximum);
      this.timeout = setTimeout(() => {
        limit.ariaHidden = String(true);
      }, 3000);
    } else {
      limit.ariaHidden = String(true);
    }
  }
}

// Features/Product-Quantity/mod.ts
customElements.define("product-quantity", Component);
